// Duration formatting for the attendance UI.
//
// Every figure on the attendance page reads in the same "Xh Ym Zs" shape, so a
// value is never ambiguous between decimal hours (2.26) and clock time (2:26).
// Two entry points because the API speaks both units: live timers are seconds,
// while persisted columns (attendance.total_hours, the monthly aggregates) are
// decimal hours.

/* Seconds → "Xh Ym Zs". Negative/NaN input floors at "0h 0m 0s". */
export const formatDuration = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${h}h ${m}m ${s}s`;
};

/* Decimal hours → "Xh Ym Zs". Note total_hours is stored to 2dp, so the
   seconds it yields are precise to ~±18s — the format is exact, the source
   value is what's rounded. */
export const formatHoursDuration = (hours) =>
  formatDuration((Number(hours) || 0) * 3600);
